import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input
} from "reactstrap";
import Papa from "papaparse";
import { importEvents } from "helpers/fakebackend_helper";

const ImportEventsModal = () => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const [modalOpen, setModalOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [parsedData, setParsedData] = useState([]);
    const [isCorrectFormat, setIsCorrectFormat] = useState(null);
    const [loading, setLoading] = useState(false);

    const requiredColumns = [
        "Item",
        "Event Name",
        "Event Date",
        "Total Invoice",
        "Total Labor Cost",
        "Non-Labor Costs",
        "Total Cost",
        "Net Profit",
        "%",
    ];

    const toggle = () => {
        setFile(null)
        setModalOpen(!modalOpen)
    };

    const handleFileChange = (e) => {
        const uploadedFile = e.target.files[0];
        setFile(uploadedFile);

        Papa.parse(uploadedFile, {
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
                const rows = results.data;
                const parsedColumns = results.meta.fields || [];

                const hasAllRequired =
                    requiredColumns.every((col) => parsedColumns.includes(col)) &&
                    parsedColumns.every((col) => requiredColumns.includes(col));

                setIsCorrectFormat(hasAllRequired ? 1 : 0);
                setParsedData(rows);
            }
        });
    };

    const importData = async () => {
        try {
            setLoading(true);
            await importEvents(user.token, parsedData);
        } catch (error) {
            console.error("Import failed:", error);
        } finally {
            setLoading(false);
            toggle();
        }
    };

    return (
        <>
            {/* Button to open modal */}
            <Button className="button-gradient-bg" onClick={toggle}>
                Import Events
            </Button>

            {/* Modal */}
            <Modal isOpen={modalOpen} toggle={toggle} centered>
                <ModalHeader toggle={toggle}>Import SpotHero Report</ModalHeader>
                <ModalBody>
                    <Input type="file" onChange={handleFileChange} accept=".csv" />

                    {file && (
                        <div className="mt-3">
                            <h6>File Information</h6>
                            <p className="mb-1">
                                <strong>Name:</strong> {file.name}
                            </p>
                            <p className="mb-1">
                                <strong>Size:</strong>{" "}
                                {(file.size / 1024 / 1024).toFixed(2)} MB
                            </p>
                            <p className="mb-1">
                                <strong>Type:</strong> {file.type || "N/A"}
                            </p>
                            <p className="mb-1">
                                <strong>Correct Format?:</strong>
                                {isCorrectFormat === 1 ? (
                                    <span className="badge bg-success ms-2">YES</span>
                                ) : isCorrectFormat === 0 ? (
                                    <span className="badge bg-danger ms-2">
                                        NO, CONTACT DEVELOPER
                                    </span>
                                ) : null}
                            </p>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Close
                    </Button>
                    {isCorrectFormat === 1 && (
                        <Button
                            color="primary"
                            onClick={importData}
                            disabled={loading}
                        >
                            {loading ? "Importing..." : "Import Data"}
                        </Button>
                    )}
                </ModalFooter>
            </Modal>
        </>
    );
};

export default ImportEventsModal;